import {Component, ComponentOptions, PartsOptions} from "@mecatran-components/component";
import {Input} from "@mecatran-components/input";

export class StopTag extends Component{
    constructor(stop){
        if (!stop) throw new Error('StopTag. Stop is mandatory')
        var componentOptions = new ComponentOptions();
        componentOptions.setDomOptions({ stop })
        super(componentOptions);
        var _stop = stop
        ;

        
    /* ======================================= */
    /* PUBLIC                                  */
    /* ======================================= */
        
        Object.defineProperty(this,'stop',{
            set : function(s){ _stop = s },
            get : function(){ return _stop }
        })


        
    /* ======================================= */
    /* PRIVATE                                 */
    /* ======================================= */

        this.initStopTag();
    }

    getIcone(isSchool){
        var icon; 
        switch(isSchool){
            case true: 
                icon = "./assets/school-white.png";
                break;
            case false:
                icon = "./assets/home-black.png";
        }

        return icon;
    }


    createLayout(){
        var stop = this.stop;
        var isSchool = stop.getIsSchool();
        var wrapper = document.createElement('div');
        wrapper.classList.add('wrapper-stop-name');
        var name = document.createElement('div');
        name.classList.add('name');
        name.innerText = stop.name;
        var city = document.createElement('div');
        city.classList.add('city');
        city.innerText = stop.city;
        wrapper.appendChild(name);
        wrapper.appendChild(city);
        var img = document.createElement('img');
        img.src = this.getIcone(isSchool);
        return [wrapper, img]
    }

    createFullLSButton(){
        var stop = this.stop;
        var isSchool = stop.getIsSchool();
        var fullLSId = "fullLS";
        this.fullLSId = fullLSId;
        var options = { 
            id : fullLSId,
            type : 'button',
            value : (isSchool) ? 'Fiche horaire scolaire' : 'Horaires scolaires'
        }
        var fullSchedulesButton = new Input(options); 
        this.addSubComponent(fullSchedulesButton,fullLSId);
    }

    createLRButton(){
        var LRId = "LR";
        this.LRId = LRId;
        var options = { 
            id : LRId,
            type : 'button',
            value : 'Horaire lignes régulières',
        }
        var terlerButton = new Input(options); 
        this.addSubComponent(terlerButton,LRId);
    }

    initStopTag(){
        var contentOptions = new PartsOptions(this.createLayout.bind(this));
        this.setContentOptions(contentOptions);

        this.buildContent();
        this.build();

        this.createFullLSButton();

        var stop = this.stop;
        var erpDest = stop.erpDest;
        var erpHome = stop.erpHome;
        if (erpDest || erpHome)  this.createLRButton();
    }

    isButton(element){ 
        return ((element.type === "button"))
    }


    onClickButton(event){
        var id = event.target.id;
        var detail = {id, stop : this.stop  }
        this.emitCustomEvent('tagEvent', detail);
    }

    onMousedown(event){
        var id = event.target.id;
        var detail = {id, stop : this.stop  }
        this.emitCustomEvent('tagMousedownEvent', detail);        
    }

    onMouseup(event){
        var id = event.target.id;
        var detail = {id, stop : this.stop  }
        this.emitCustomEvent('tagMouseupEvent', detail);        
    }



    onTest(event){
        console.log('clicked on a button',event.detail)
    }

    /* ======================================= */
    /* Overload                                */
    /* ======================================= */
    defineEventListeners(eventManager){
        eventManager.on('click',this.isButton,this.onClickButton.bind(this),false);
        eventManager.on('mousedown', ()=>true, this.onMousedown.bind(this), false);
        eventManager.on('mouseup', ()=>true, this.onMouseup.bind(this), false);
        //eventManager.on('selectEvent',()=>true,this.onTest.bind(this))
    }

    createContainerNode(domOptions){
        var isSchool = domOptions.stop.getIsSchool();
        var div = document.createElement('div');
        div.classList.add('stop-tag');
        var klass = (isSchool) ? 'school-tag' : 'home-tag';
        div.classList.add(klass);
        return div; 
    }


    /* ======================================= */
    /* PUBLIC                                  */
    /* ======================================= */  
    setActive(){
        this.getDomNode().classList.add('active');
    }

    setUnactive(){
        this.getDomNode().classList.remove('active');
    }


}


/**
 * StopTag options interface extends componentoptions
 * -------------------------
 * stop - Stop 
 */